import { useQuery } from '@tanstack/react-query';
import { gqlSimpleApplicationStatsQuery } from 'src/app.core/linkareer/gql/linkareer.graphql';
import { linkareerGqlRequest } from 'src/app.core/linkareer/module/linkareerGqlRequest';
import {
  ApplicationStatus,
  SimpleApplicationStatsQueryResult,
  SimpleApplicationStatsQueryVariables,
} from 'src/app.core/linkareer/types/gql.types';

type Params = {
  skip?: boolean;
};

const REVIEWED_STATUSES = [
  ApplicationStatus.UNDER_REVIEW,
  ApplicationStatus.DOCUMENT_PASS,
  ApplicationStatus.INTERVIEWING,
  ApplicationStatus.FINAL_PASS,
  ApplicationStatus.REJECTED,
];

const requestSimpleApplicationStats = async () => {
  return await linkareerGqlRequest<
    SimpleApplicationStatsQueryResult,
    SimpleApplicationStatsQueryVariables
  >({
    query: gqlSimpleApplicationStatsQuery,
    variables: {
      filterBy: {
        status: REVIEWED_STATUSES,
      },
    },
  });
};

const useHasNewApplications = ({ skip = false }: Params = {}) => {
  const { data, isError } = useQuery(
    ['linkareerSimpleApplicationStats', REVIEWED_STATUSES],
    async () => requestSimpleApplicationStats(),
    {
      enabled: !skip,
      retry: false,
    }
  );

  return {
    hasNewApplications: !isError && !!data?.simpleApplicationStats?.hasUnviewedChanges,
  };
};

export default useHasNewApplications;
